export const mockData = {
  testimonials: [
    {
      id: 0,
      name: "Martina (Anja's Mum)",
      grade: "Grade 5 Foundation - Jan 2026 🔥",
      comment: "Anja got foundation maths result and she got a 5 so she will be allowed to sit a higher paper! Thank you again for all the hard work with her. She was failing and in just 3.5 months of intensive tutoring, she passed!",
      avatar: "MA",
      isNew: true
    },
    {
      id: 1,
      name: "Sarah Johnson",
      grade: "Grade 9 (Higher Tier)",
      comment: "Dr. Omakobia's teaching approach is exceptional. I went from a Grade 5 to a Grade 9 in just 6 months. His real-world examples made everything click!",
      avatar: "SJ"
    },
    {
      id: 2,
      name: "James Peterson",
      grade: "Grade 7 (Foundation Tier)",
      comment: "I struggled with maths for years, but Dr. Michael's patient teaching style and practice-focused approach helped me achieve my target grade. Highly recommend!",
      avatar: "JP"
    },
    {
      id: 3,
      name: "Emma Williams",
      grade: "Grade 8 (Higher Tier)",
      comment: "As an IGCSE examiner, Dr. Omakobia knows exactly what examiners look for. His insights were invaluable for my GCSE success!",
      avatar: "EW"
    },
    {
      id: 4,
      name: "Mohammed Ali",
      grade: "Grade 6 (Foundation Tier)",
      comment: "The group sessions are amazing value. Dr. Michael creates a supportive environment where we all help each other learn. Best decision I made!",
      avatar: "MA"
    }
  ],
  
  services: [
    {
      id: 1,
      tier: "Higher Tier",
      description: "Advanced GCSE Maths tuition for students targeting grades 4-9. Covers algebraic techniques, geometry, trigonometry, calculus, and probability.",
      features: [
        "Exam board aligned content (AQA, Edexcel, OCR)",
        "Problem-solving strategies",
        "Past paper practice",
        "Examiner insights and tips",
        "Real-world application examples"
      ],
      icon: "TrendingUp"
    },
    {
      id: 2,
      tier: "Foundation Tier",
      description: "Comprehensive GCSE Maths tuition for students targeting grades 1-5. Focus on building confidence and mastering core concepts.",
      features: [
        "Core mathematical concepts",
        "Step-by-step explanations",
        "Regular practice sessions",
        "Confidence building approach",
        "Personalized support for SEN needs"
      ],
      icon: "BookOpen"
    },
    {
      id: 3,
      tier: "Homeschool Sessions",
      description: "Dedicated daytime group sessions specifically designed for homeschooled students. Available 8am - 4pm daily.",
      features: [
        "Flexible daytime scheduling (8am - 4pm)",
        "Small group environment",
        "Social learning with peers",
        "Foundation & Higher tier options",
        "Structured GCSE curriculum",
        "Regular progress updates for parents",
        "All exam boards covered"
      ],
      icon: "Users"
    }
  ],
  
  faqs: [
    {
      id: 1,
      question: "What is the class size for group tuition?",
      answer: "We keep our groups small (typically 4-6 students) to ensure each student receives personalized attention while benefiting from peer learning."
    },
    {
      id: 2,
      question: "How long are the tuition sessions?",
      answer: "Each session is 1 hour long. We recommend at least 2 sessions per week for optimal progress, especially approaching exam dates."
    },
    {
      id: 3,
      question: "Which exam boards do you cover?",
      answer: "We cover all major exam boards including AQA, Edexcel, OCR, and WJEC. Dr. Omakobia's experience as an IGCSE examiner provides valuable insights across all boards."
    },
    {
      id: 4,
      question: "Do you offer support for students with SEN needs?",
      answer: "Absolutely! Dr. Omakobia has 12 years of experience working with students with Special Educational Needs and adapts teaching methods to suit individual learning styles."
    },
    {
      id: 5,
      question: "Can I switch between Higher and Foundation tier?",
      answer: "Yes, we can adjust your tier based on your progress and target grades. We'll discuss the best option for you during your sessions."
    }
  ]
};
